import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import exam1 from "../../Images/exam1.png";
import exam2 from "../../Images/exam2.png";
import exam3 from "../../Images/exam3.png";
import exam4 from "../../Images/exam4.png";
import exam5 from "../../Images/exam5.png";
import exam6 from "../../Images/exam6.png";
import exam7 from "../../Images/exam7.png";
import exam8 from "../../Images/exam8.png";
import exam9 from "../../Images/exam9.png";
import exam10 from "../../Images/exam10.png";
import exam11 from "../../Images/exam11.png";

const categories = [
  {
    title: "SSC",
    questions: "150k+ Questions",
    image: exam1,
    accent: "from-[#eef2ff] to-white",
  },
  {
    title: "Banking",
    questions: "85k+ Questions",
    image: exam2,
    accent: "from-[#ecfeff] to-white",
  },
  {
    title: "Railway",
    questions: "70k+ Questions",
    image: exam3,
    accent: "from-[#fff7ed] to-white",
  },
  {
    title: "UPSC",
    questions: "95k+ Questions",
    image: exam4,
    accent: "from-[#fef3c7] to-white",
  },
  {
    title: "State PSCs",
    questions: "120k+ Questions",
    image: exam5,
    accent: "from-[#eef2ff] to-white",
  },
  {
    title: "Police",
    questions: "85k+ Questions",
    image: exam6,
    accent: "from-[#ecfeff] to-white",
  },
  {
    title: "Teaching",
    questions: "70k+ Questions",
    image: exam7,
    accent: "from-[#fff7ed] to-white",
  },
  {
    title: "Defence",
    questions: "95k+ Questions",
    image: exam8,
    accent: "from-[#fef3c7] to-white",
  },
  {
    title: "Engineering / Technical",
    questions: "120k+ Questions",
    image: exam9,
    accent: "from-[#eef2ff] to-white",
  },
  {
    title: "Medical / Enterance",
    questions: "85k+ Questions",
    image: exam10,
    accent: "from-[#ecfeff] to-white",
  },
  {
    title: "Other Government Exams",
    questions: "70k+ Questions",
    image: exam11,
    accent: "from-[#fff7ed] to-white",
  },
];

function ExploreCategories() {
  const sliderRef = useRef(null);

  useEffect(() => {
    const el = sliderRef.current;
    if (!el) return;

    let animationFrame;
    const speed = 1.5;

    const scroll = () => {
      if (!el) return;
      el.scrollLeft += speed;
      if (el.scrollLeft >= el.scrollWidth / 2) {
        el.scrollLeft = 0;
      }
      animationFrame = requestAnimationFrame(scroll);
    };

    animationFrame = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(animationFrame);
  }, []);

  return (
    <section className="w-full bg-[#faf7ff] px-4 py-10 sm:px-6">
      <div className="mx-auto rounded-[2rem] border border-white/70 bg-white/95 p-5 shadow-[0_24px_80px_rgba(91,78,229,0.10)] sm:p-7 lg:p-8">
        <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h2 className="mt-2 text-2xl font-bold text-[#1f1b4d] sm:text-3xl">
             India’s Top Competitive Exams
            </h2>
          </div>
        </div>

        <div
          ref={sliderRef}
          className="-mx-2 flex overflow-hidden px-2"
        >
          <div className="flex gap-4 min-w-full shrink-0">
            {[...categories, ...categories].map(({ title, questions, image, accent }, index) => (
              <Link
                key={`${title}-${index}`}
                to="/login"
                className={`group min-w-[100px] sm:min-w-[200px] md:min-w-[220px] flex-1 flex items-center gap-3 rounded-[1.4rem] border border-[#efeafd] bg-gradient-to-br ${accent} p-4 sm:p-5 shadow-[0_10px_35px_rgba(91,78,229,0.08)] transition duration-300 hover:-translate-y-1 hover:border-[#d9ccff]`}
              >
                <div className="flex">
                  <img src={image} alt={title} className="h-24 w-24 sm:h-28 sm:w-28 object-contain" />
                </div>

                <div className="min-w-0 flex-1 text-left">
                  <h3 className="text-sm sm:text-base font-bold text-[#1f1b4d]">{title}</h3>
                  <p className="mt-1 text-xs sm:text-sm font-medium text-[#6f6a8a]">
                    {questions}
                  </p>
                </div>

                <ChevronRight
                  size={20}
                  className="shrink-0 text-[#9b94c9] transition group-hover:translate-x-1 group-hover:text-[#6b46e8]"
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ExploreCategories;
